/**
 * Ссылка на публичный профиль участника в клиентском приложении.
 */
export function clientMemberProfileLink(author) {
  if (!author?.id) return null;
  const role = author.role;
  if (
    role === "client" ||
    role === "owner" ||
    role === "admin" ||
    role === "trainer"
  ) {
    return `/app/members/${author.id}`;
  }
  return null;
}
